import { FC } from 'react';

import { Box } from '@mui/material';

const COMPANY_LOGOS = [
  { src: '/img/logo/bloomberg.svg', alt: 'Bloomberg' },
  { src: '/img/logo/exxon-mobil.svg', alt: 'Exxon Mobil' },
  { src: '/img/logo/totalenergies-logo.png', alt: 'Total Energies' },
  { src: '/img/logo/woodmackenzie.svg', alt: 'Woodmackenzie' },
  { src: '/img/logo/citi.svg', alt: 'Citi' }
] as const;

/**
 * Displays a grid of company logos for the "Trusted By" section.
 * Shows logos of major clients/partners using the platform.
 */
export const LogoGrid: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        mt: 4,
        gap: 4,
        justifyContent: 'space-evenly',
        alignItems: 'center',

        img: {
          height: {
            xs: '12px',
            lg: '19px'
          }
        }
      }}
    >
      {COMPANY_LOGOS.map(logo => (
        <img
          key={logo.src}
          alt={logo.alt}
          decoding='async'
          fetchPriority='low'
          loading='lazy'
          src={logo.src}
        />
      ))}
    </Box>
  );
};
